document.addEventListener("DOMContentLoaded", () => {
	// Blog post table of contents
	const tocDesktopLinks = document.querySelectorAll("#tocDesktop a");
	const tocMobileLinks = document.querySelectorAll("#tocMobile a");
	const tocMobile = document.getElementById("tocMobile");
	const tocTrigger = document.getElementById("tocTrigger");

	if (document.body.classList.contains("favyBlogPost")) {
		const tocHeaders = document.querySelectorAll(".tocHeader");
		let tocHeaderPositions = [];

		const calculateHeaderPositions = () =>
			Array.from(tocHeaders).map((header) =>
				Math.floor(header.getBoundingClientRect().top + window.scrollY),
			);

		window.addEventListener("load", () => {
			tocHeaderPositions = calculateHeaderPositions();
		});

		window.addEventListener("resize", () => {
			tocHeaderPositions = calculateHeaderPositions();
		});

		window.addEventListener("scroll", () => {
			// Close the mobile TOC when the user scrolls if open
			tocMobile?.classList.add("tw:hidden");
			document
				.querySelector("#tocTrigger img")
				?.classList.remove("tw:rotate-180");

			// Remove active class from all links
			tocDesktopLinks.forEach((link) => link.classList.remove("tocActive"));
			tocMobileLinks.forEach((link) => link.classList.remove("tocActive"));

			// Add active class to the link that corresponds to the header in view
			const windowPos = window.scrollY;
			for (let i = tocHeaderPositions.length - 1; i >= 0; i--) {
				if (windowPos >= tocHeaderPositions[i]) {
					tocDesktopLinks[i]?.classList.add("tocActive");
					tocMobileLinks[i]?.classList.add("tocActive");
					break;
				}
			}
		});
	}

	// Show/Hide Mobile TOC
	tocTrigger?.addEventListener("click", () => {
		const header = document.getElementById("header");
		header?.classList.remove("headroom--unpinned");
		header?.classList.add("headroom--pinned");
		tocMobile?.classList.toggle("tw:hidden");
		tocTrigger.querySelector("img")?.classList.toggle("tw:rotate-180");
	});

	// Hide Mobile TOC on clicking the links
	tocMobileLinks?.forEach((link) => {
		link.addEventListener("click", () => {
			tocMobile?.classList.toggle("tw:hidden");
		});
	});
});
